import { AccessStorage } from "../storage/AccessStorage";
import { APIRequest } from "./api";

export class TestShootingSmsBody {
  phone = null;
  message = null;
  replacements = {
    url: {
      type: null,
      value: null,
    },
    beneficio: {
      type: null,
      value: null,
    },
    valorrecebido: null,
  };

  constructor(data) {
    this.phone = data.phone;
    this.message = data.message;
    if (data.replacements) {
      const { url, beneficio, valorrecebido } = data.replacements;
      this.replacements.url = url;
      this.replacements.beneficio = beneficio;
      this.replacements.valorrecebido = valorrecebido;
    }
  }

  toJSON() {
    const { phone, message, replacements } = this;
    const returnBody = {
      phone,
      message,
    };

    if (replacements) {
      returnBody.replacements = replacements;
    }

    return returnBody;
  }
}

export class TestShootingAPI {
  static async request({ endpoint, data = {}, params = {}, method = "get" }) {
    return await APIRequest({
      service: "environments/test-shooting",
      endpoint: endpoint || "",
      method: method || "get",
      data: data || {},
      params: params || {},
      ignoreVersion: true,
    });
  }

  static async requestAuthenticated({
    endpoint,
    data = {},
    params = {},
    method = "get",
  }) {
    return await APIRequest({
      service: "environments/test-shooting",
      endpoint: endpoint || "",
      method: method || "get",
      headers: {
        Authorization: `Bearer ${AccessStorage.getAccessToken()}`,
      },
      data: data || {},
      params: params || {},
      ignoreVersion: true,
    });
  }

  /**
   *
   * @param {TestShootingSmsBody} testShootingSmsBody
   * @returns {Promise<Response>}
   */
  static async postSms(testShootingSmsBody) {
    return await TestShootingAPI.requestAuthenticated({
      endpoint: `/sms`,
      method: "post",
      data: testShootingSmsBody,
    });
  }
}
